import { OnInit, Component, ViewChild, EventEmitter, Output ,Input} from "@angular/core";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { TranslateService } from "@ngx-translate/core";
import { Claims } from "src/app/_models/common/claims";
import { environment } from "src/environments/environment";
import { NgOption } from "@ng-select/ng-select";
import { ApiRequest,IApiresponse ,CompanyCardAccessGrantsStatusEnum} from "src/app/_models";
import { CreditCardService } from "src/app/_services/credit-card/credit-card.service";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { ToastrService } from "ngx-toastr";
import { AlertService } from "src/app/alert-panel/alert.service";
import { BaseComponent } from "src/app/shared/base/base-component";
import { MultipleCompaniesService } from 'src/app/_services/multiple-companies/multiple-companies.service';
import {CCCompanyAccessGrantRequestPanelInputModel,
    DetailsForCompanyCardAccessGrantRequest,CompanyCardAccessGrantDetail,
    SaveCompanyCardAccessGrantsMappingRequest,CompanyCardAccessGrantsMapping,SaveCompanyCardAccessGrantsRequest } from 'src/app/_models/multiple-companies/multiple-companies';
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";

@Component({
    selector: "cc-company-access-grant-request-panel",
    templateUrl: "./cc-company-access-grant-request-panel.component.html",
    standalone: false
})

export class CCCompanyAccessGrantRequestPanelComponent extends BaseComponent implements OnInit {

    @Output() closePanelEvent = new EventEmitter<boolean>();
    @Output() submitEvent = new EventEmitter<any>();
    
    @Input() inputModel: CCCompanyAccessGrantRequestPanelInputModel;

    claimsSubscription: Subscription;
    userActionEventSubscription: Subscription;
    claims: Claims;
    hasFormChanges: boolean = false;

    disableSaveButton: boolean = true;


    companyList: CompanyCardAccessGrantDetail[] = [];

    showRejectConfirmationAlert: boolean = false;
    rejectConfirmationAlertModel: AlertPanelModel;
    selectedCompany: CompanyCardAccessGrantDetail ;

    constructor(
        private toastr: ToastrService,
        private router: Router,
        private claimsService: ClaimsService,
        private translate: TranslateService,
        private alertService: AlertService,
        private creditCardService: CreditCardService,
        private multipleCompaniesService: MultipleCompaniesService,

    ) {
        super();
        this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
        });

         this.fnObserveUnsavedChangesAlerts();
    }

    ngOnInit(): void {
        this.fnGetCompanyCardAccessGrantDetailList(); 
    }

    ngOnDestroy() {
    this.claimsSubscription.unsubscribe();
    this.userActionEventSubscription.unsubscribe();
    }

    canDeactivate() {
        return !this.hasFormChanges;
    }

    fnObserveUnsavedChangesAlerts() {
        this.userActionEventSubscription = this.alertService.getUserActionEvent().subscribe(action => {
            if (action) {
                this.closePanelEvent.emit(true);
            }
        });
    }

    fnClosePanel() {
        if (this.canDeactivate()) {
            this.closePanelEvent.emit(true);
        }
        else {
            this.alertService.onFormClosed();
        }
    }

  fnGetCompanyCardAccessGrantDetailList() {

        let request = new ApiRequest<DetailsForCompanyCardAccessGrantRequest>("GetCompanyCardAccessGrantDetailList", environment.applicationVersion, environment.requestId);

        let requestInfo = new DetailsForCompanyCardAccessGrantRequest();
        requestInfo.organisationId = this.claims.OrgId;
        requestInfo.userId = this.inputModel.userId;
        request.requestInfo = requestInfo;
        
        this.multipleCompaniesService.GetCompanyCardAccessGrantRequestedList(request)
        .subscribe((response: any) => {
           if (response && response.responseInfo != null) { 
              this.companyList = response.responseInfo.companyList;

              if(this.inputModel?.companyCardAccessGrantsId > 0){
                this.companyList =  this.companyList.filter(c=>c.companyCardAccessGrantsId == this.inputModel.companyCardAccessGrantsId);
              }

              this.companyList = this.companyList.map(item=>{
                 item.isAccessAssigned = true;
                 return item;
              });

             }
          });
      }


    fnShowRejectConfirmationAlert() {
        this.rejectConfirmationAlertModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [this.translate.instant("are_you_sure_you_want_to_reject")],

            this.translate.instant("cancel_label"),
            this.translate.instant("label_confirm"),
            true,
            this.translate.instant("please_review_or_confirm"));
        this.showRejectConfirmationAlert = true;
    }

    fnRejectAlertPanelReceiver(returnValue) {
        if (returnValue) {
             this.fnUpdateCompanyCardAccessGrants(CompanyCardAccessGrantsStatusEnum.Rejected);
        }
        this.disableSaveButton = false;
        this.rejectConfirmationAlertModel = null;
        this.showRejectConfirmationAlert = false;
    }

    fnApproveRejectCompanyAccessRequest(company,status){
        this.selectedCompany = company;
        if(status == CompanyCardAccessGrantsStatusEnum.Approved){
           this.fnUpdateCompanyCardAccessGrants(CompanyCardAccessGrantsStatusEnum.Approved);
        }
        else{
            this.fnShowRejectConfirmationAlert();
        }
    }

fnUpdateCompanyCardAccessGrants(status) {
  this.disableSaveButton = true;

  let request = new ApiRequest<SaveCompanyCardAccessGrantsRequest>("UpdateStatusCompanyCardAccessGrants", environment.applicationVersion, environment.requestId);

  let requestInfo = new SaveCompanyCardAccessGrantsRequest();

  requestInfo.companyCardAccessGrantsId = this.selectedCompany.companyCardAccessGrantsId;
  requestInfo.userId = this.inputModel.userId;
  requestInfo.organisationId = this.claims.OrgId;
  requestInfo.companyId = this.selectedCompany.companyId;
  requestInfo.isJustificationRequired =  (status  == CompanyCardAccessGrantsStatusEnum.Approved 
    ? this.selectedCompany.isJustificationRequired : false);
  requestInfo.status = status;
  requestInfo.updatedBy = this.claims.UserId;
  requestInfo.userName = this.claims.FinanceManager;
  request.requestInfo = requestInfo;

  localStorage.setItem("UpdateStatusCompanyCardAccessGrants" + this.claims.OrgId, JSON.stringify(new Date().toUTCString()));

   this.multipleCompaniesService.UpdateStatusCompanyCardAccessGrants(request)
      .subscribe((response: IApiresponse<any>) => {
          if (response) {
            this.toastr.success(this.translate.instant("success"));
            this.selectedCompany = null;
            this.submitEvent.emit(true);
          }
          else {
              this.toastr.error(this.translate.instant("failed"));
          }
          this.disableSaveButton = false;
         
      });
}

}
